import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vb-tilepicker',
  templateUrl: './tilepicker.component.html',
  styleUrls: ['./tilepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TilepickerComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class TilepickerComponent implements OnInit {
  @Input() element: any;
  @Input() disableField: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  disabled: boolean;
  selectedTile: string;
  tiles: any[] = [
    { name: 'Type 1', type: 'type_1', imgSrc: 'image-tile-1' },
    { name: 'Type 2', type: 'type_2', imgSrc: 'image-tile-2' },
    { name: 'Type 3', type: 'type_3', imgSrc: 'image-tile-3' }
  ];

  ngOnInit(): void {
    console.log(this.element);
  }

  handleChange(tile: string) {
    this.selectedTile = tile;
    this.onChange(tile); // <-- call function to let know of a change
  }

  // this method sets the value programmatically
  writeValue(value: any) {
    this.selectedTile = value ? value : 'type_1';
  }
  // upon UI element value changes, this method gets triggered
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  // upon touching the element, this method gets triggered
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
